<template>
<div class="weui-tab">
    <div class="weui-tab__panel">
        <keep-alive>
            <component :is="currentTab"></component>
        </keep-alive>
    </div>

    <div class="weui-tabbar">
        <a href="javascript:;" class="weui-tabbar__item" :class="tabItemClass(0)" @click="tabItemClicked(0)">
            <svg class="weui-tabbar__icon" :style="tabIconClass(0)"><use xlink:href="#compass" /></svg>
            <p class="weui-tabbar__label">发现</p>
        </a>
        <a href="javascript:;" class="weui-tabbar__item" :class="tabItemClass(1)" @click="tabItemClicked(1)">
            <svg class="weui-tabbar__icon" :style="tabIconClass(1)"><use xlink:href="#store" /></svg>
            <p class="weui-tabbar__label">商城</p>
        </a>
        <a href="javascript:;" class="weui-tabbar__item" :class="tabItemClass(2)" @click="tabItemClicked(2)">
            <svg class="weui-tabbar__icon" :style="tabIconClass(2)"><use xlink:href="#paw" /></svg>
            <p class="weui-tabbar__label">足迹</p>
        </a>
        <a href="javascript:;" class="weui-tabbar__item" :class="tabItemClass(3)" @click="tabItemClicked(3)">
            <svg class="weui-tabbar__icon" :style="tabIconClass(3)"><use xlink:href="#user" /></svg>
            <p class="weui-tabbar__label">我</p>
        </a>
    </div>
</div>
</template>

<script>
import "@/assets/svg/user.svg";
import "@/assets/svg/paw.svg";
import "@/assets/svg/compass.svg";
import "@/assets/svg/store.svg";
import Finder from './Finder'
import History from './History'
import Me from './Me'
import Store from './Store'

export default {
    name: 'Home',
    data() {
        return {
            tabs:['Finder', 'Store', 'History', 'Me'],
//            selectedIndex: 0,
        };
    },
    computed:{
        currentTab(){
            return this.tabs[this.selectedIndex];
        },
        selectedIndex: {
            get () {
                return this.$store.state.home.tabSelectedIndex
            },
            set (val) {
                this.$store.commit("home/tabSelectedIndex", val)
            }
        }
    },
    methods: {
        tabItemClass(index) {
            return this.selectedIndex == index ? 'weui-bar__item_on' : '';
        },
        tabIconClass(index) {
            return this.selectedIndex == index ? 'fill: #07C160' : 'fill: #888';
        },
        tabItemClicked(index) {
            this.selectedIndex = index;
        },
    },
    components: {
        Finder,
        History,
        Me,
        Store
    }
}
</script>

<style scoped>
.icon {
    width: 24px;
    height: 24px;
}
</style>
